import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    scrollX: {
        overflowX: "auto",
        WebkitOverflowScrolling: "touch",
    },
    labelColumn: {
        display: "flex",
        flexDirection: "column",
        gap: 20,
        padding: '12px 0px'
    },
    rulesContainer: {
        display: "flex",
        flexDirection: "column",
        gap: 20,
        minWidth: 800,
    },
    labelSection: {
        display: "flex",
        flexDirection: "column",
        gap: 4,
        height: 40,
        itemsAlign: "center",
    },
    label: {
        fontSize: 14,
        color: "#344054",
        fontWeight: 500,
        lineHeight: "20px",
    },
    note: {
        fontSize: 12,
        color: "#98A2B3",
        lineHeight: "18px",
        fontStyle: "italic",
    },
    inputsSection: {
        display: "grid",
        gridTemplateColumns: "auto auto",
        gap: 24,
        alignItems: "center",
        "@media (max-width: 1024px)": {
            gap: 16,
        },
    },
    helperText: {
        fontSize: 'var(--Font-size-text-sm, 14px)',
        fontFamily: "Be VietNam Pro",
        color: "var(--colors-text-text-secondary-700, #344054)",
        fontWeight: 600,
        lineHeight: "var(--Line-height-text-sm, 20px)",
        marginLeft: 8,
    },
}));
